import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['input'];

  open(event) {
    // The date text keeps the browser's normal caret and keyboard behaviour.
    if(event.target === this.inputTarget || this.inputTarget.disabled) return;
    if(typeof this.inputTarget.showPicker === 'function') {
      try { this.inputTarget.showPicker(); return; } catch (_) { /* Unsupported browser context. */ }
    }
    this.inputTarget.focus();
    this.inputTarget.click();
  }
}
